/**
 * Barrel for the Contract End Date section (SE-4881).
 * @module features/contracts/components/ContractEndDateSection
 */

export { default } from "./ContractEndDateSectionContainer";
export type { ContractEndDateSectionContainerProps } from "./ContractEndDateSectionContainer";
